import { render, staticRenderFns } from "./AboutApplyfor.vue?vue&type=template&id=0b66104e&scoped=true&"
import script from "./AboutApplyfor.vue?vue&type=script&lang=js&"
export * from "./AboutApplyfor.vue?vue&type=script&lang=js&"
import style0 from "./AboutApplyfor.vue?vue&type=style&index=0&id=0b66104e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b66104e",
  null
  
)

export default component.exports